var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useImmer } from 'use-immer';
import { useState, useEffect } from 'react';
var noop = function () { };
var promiseById = {};
export function useAsync(query, props) {
    var id = useState(Math.random())[0];
    var _a = props || {}, runOnInit = _a.runOnInit, _b = _a.onResult, onResult = _b === void 0 ? noop : _b, _c = _a.onError, onError = _c === void 0 ? noop : _c;
    var _d = useImmer({
        isInitial: true,
        isLoading: false,
        result: undefined,
        promiseCancelable: undefined,
    }), state = _d[0], setState = _d[1];
    var promiseCancelable = state.promiseCancelable;
    useEffect(function () {
        function handlePromise(promiseCancelable) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var result, error, errorResponse_1, canUpdateState;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            promiseById[id] = promiseCancelable;
                            setState(function (state) {
                                state.isLoading = true;
                            });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, promiseCancelable.promise];
                        case 2:
                            result = _b.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            errorResponse_1 = _b.sent();
                            error = errorResponse_1;
                            return [3 /*break*/, 4];
                        case 4:
                            canUpdateState = !promiseCancelable.isCancelled;
                            if (canUpdateState) {
                                if (error) {
                                    setState(function (state) {
                                        state.isLoading = false;
                                        state.isInitial = false;
                                        state.promiseCancelable = undefined;
                                        promiseById[id] = undefined;
                                    });
                                    if ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.endsWith(' _')) {
                                        alert(error.message.replace(' _', ''));
                                    }
                                    onError === null || onError === void 0 ? void 0 : onError(error);
                                }
                                else {
                                    setState(function (state) {
                                        state.result = result;
                                        state.isLoading = false;
                                        state.isInitial = false;
                                        state.promiseCancelable = undefined;
                                        promiseById[id] = undefined;
                                    });
                                    onResult === null || onResult === void 0 ? void 0 : onResult(result);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (promiseCancelable) {
            handlePromise(promiseCancelable);
            return function () {
                promiseCancelable.cancel();
            };
        }
    }, [promiseCancelable]);
    function reset() {
        setState(function (state) {
            state.result = undefined;
        });
    }
    function run(params) {
        if (promiseById[id]) {
            return promiseById[id];
        }
        else {
            var promiseCancelable_1 = makeCancelable(query(params));
            promiseById[id] = promiseCancelable_1;
            setState(function (state) {
                state.promiseCancelable = promiseCancelable_1;
            });
            return promiseCancelable_1.promise;
        }
    }
    useEffect(function () {
        if (runOnInit) {
            run();
        }
    }, [runOnInit]);
    return __assign(__assign({}, state), { buttonProps: {
            onClick: function () { return run(); },
            isLoading: state.isLoading,
        }, run: run,
        reset: reset });
}
function makeCancelable(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (result) {
            if (!isCancelled) {
                resolve(result);
            }
        }, function (error) {
            if (!isCancelled) {
                reject(error);
            }
        });
    });
    return {
        promise: wrappedPromise,
        isCancelled: isCancelled,
        cancel: function () {
            promise.isCancelled = true;
            isCancelled = true;
        },
    };
}
